module.exports = __webpack_public_path__ + "static/29-ec2f74dd48ccca053615750f0de23a63.jpg";